import React from 'react'
import { Box, Button, Link, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { J2Add } from '@e3dc-react/icons'
import useModals from 'src/Hooks/useModals'
import { useDispatch } from 'react-redux'
import { refreshApiView } from '@e3dc-react/shell/State/ApiView/ApiViewActions'
import GoogleAgreement from './GoogleAgreement'
import { Trans } from 'react-i18next'
import { SHOWROOM_LINK } from 'src/Configuration'

const useStyles = makeStyles()(theme => ({
  showoroomLink: {
    cursor: 'pointer',
  },
}))

interface Props {
  companyId: number
  googleAgreed: boolean
}

/**
 * Empty view if for the showrooms table
 * @param googleAgreed - indicates if user has agreed google agreement, which is needed to get the coordinates of the users address
 */
const CompanyShowRoomsEmptyView: React.VFC<Props> = ({ companyId, googleAgreed }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const { openCompanyShowroomModal } = useModals()
  const dispatch = useDispatch()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        spacing: 6,
        overflow: 'hidden',
        width: '100%',
      }}
    >
      <Typography variant="h2" sx={{ marginTop: 2 }}>
        <Trans i18nKey="administration.companyManagement.showroom.empty-view.title">
          translation-part-1
          <Link
            className={classes.showoroomLink}
            onClick={e => {
              e.preventDefault()
              window.open(SHOWROOM_LINK, '_blank')
            }}
          >
            link
          </Link>
        </Trans>
      </Typography>
      {googleAgreed ? (
        <Button
          sx={{ marginTop: 2 }}
          startIcon={<J2Add />}
          variant="outlined"
          onClick={() => {
            openCompanyShowroomModal({
              entityAccess: 'create',
              data: null,
              onSave: () => dispatch(refreshApiView()),
              companyId,
            })
          }}
        >
          {t('administration.companyManagement.showroom.empty-view.button-text')}
        </Button>
      ) : (
        <GoogleAgreement />
      )}
    </Box>
  )
}

export default CompanyShowRoomsEmptyView
